

import { useState, useEffect } from 'react';
//import CommentBox from '../../../components/CommentBox/CommentBox';
import Footer from '../../../components/Footer/Footer';
import InnerNav from '../../../components/InnerNav/InnerNav';
import axios from 'axios';
import Zodiac from '../../../components/ZodiacSign/Zodiac';
import './DoGhati.scss';
import MuhuratLink from '../../../components/MuhuratLink/MuhuratLink';
import city from '../../../city.json'

const DoGhati = () => {

const doGhatiDivisionTooltips = {
  "Pratah": "Early morning period from sunrise, considered good for starting daily activities.",
  "Sangava": "Late morning segment, a favorable time for various rituals and work.",
  "Madhyahna": "Midday period, good for rest and important spiritual observances.",
  "Madhyahna - Abhijit Muhurat": "Special midday Muhurat known as Abhijit, considered highly auspicious for important tasks.",
  "Aparahna": "Afternoon segment, generally favorable for productive work and rituals.",
  "Aparahna - Vijay Muhurat": "A specific afternoon Muhurat called Vijay Muhurat, auspicious for success.",
  "Sayahna": "Evening period, suitable for winding down and certain religious activities.",
  "Pradosha - Sayan Sandhya": "Early evening twilight, an auspicious time for Pradosha vrata and prayers.",
  "Pradosha - 1/2 Sayan Sandhya": "Mid early evening, part of the Pradosha time for special rituals.",
  "Pradosha": "Complete Pradosha period, important for devotional practices and worship.",
  "Ratri": "Night time period, used for rest and night prayers.",
  "Nishita - Mahanishita Muhurat": "Late night Muhurat, considered very powerful and auspicious for spiritual activities.",
  "Arunodaya - 1/2 Pratah Sandhya": "Pre-dawn period, marking the transition from night to morning.",
  "Arunodaya - Pratah Sandhya": "Full dawn period, auspicious for beginning new ventures and prayers."
};



const parseTime = (timeStr, baseDate = new Date()) => {
  if (typeof timeStr !== "string" || !timeStr.trim()) return null;

  // Extract only the first time part before any comma or space after AM/PM
  // For example: "01:36 PM, Jul 19" => "01:36 PM"
  const cleanedTimeStr = timeStr.split(",")[0].trim();

  const [raw, meridian] = cleanedTimeStr.split(" ");
  if (!raw || !meridian) return null;

  let [hours, minutes] = raw.split(":").map(Number);
  if (meridian.toLowerCase() === "pm" && hours < 12) hours += 12;
  if (meridian.toLowerCase() === "am" && hours === 12) hours = 0;

  const date = new Date(baseDate);
  date.setHours(hours, minutes, 0, 0);
  return date;
};


  const months = [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
  ];

  const [currentDate, setCurrentDate] = useState(new Date());
  const [location, setLocation] = useState("Kolkata");
  //const [timeFormat, setTimeFormat] = useState("12"); // "12", "24", or "24Plus"
   const [doghati, setdoghati] = useState(null);
    const [currentLagna, setCurrentLagna] = useState(null);


      // Temporary states for user input for submit button
const [tempDate, setTempDate] = useState(currentDate);
const [tempLocation, setTempLocation] = useState("Kolkata");
const [suggestions, setSuggestions] = useState([]);


  useEffect(() => {
    const fetchData = async () => {
  const formattedDate = currentDate.toISOString().split("T")[0];
      if (!location || location.trim() === '') return;
      try {
        const res = await axios.get(`https://core-c343.onrender.com/api/doghati?date=${formattedDate}&location=${encodeURIComponent(location)}`);
        setdoghati(res.data.doGhatiMuhurat);
console.log("Segments data:", res.data.doGhatiMuhurat?.segments);

const now = new Date();

 const currentSlot = res.data.doGhatiMuhurat?.segments?.find(({  start, end }) => {
  const startDate  = parseTime(start, currentDate);
  const endDate  = parseTime(end, currentDate);

  if (endDate < startDate) {
    // Handle midnight wrap
    return now >= startDate || now <= endDate;
  }

  return now >= startDate && now <= endDate;
});

setCurrentLagna(currentSlot || null);




      } catch (err) {
        console.error("Error fetching Panchaka:", err);
      }
    };

    fetchData();
  }, [currentDate, location]);

  const handlePrevDay = () => {
    const prev = new Date(currentDate);
    prev.setDate(prev.getDate() - 1);
    setCurrentDate(prev);
  };

  const handleNextDay = () => {
    const next = new Date(currentDate);
    next.setDate(next.getDate() + 1);
    setCurrentDate(next);
  };

  const handleDateInput = (e) => {
    setTempDate(new Date(e.target.value));
  };

const handleMonthClick = (monthIndex) => {
  const newDate = new Date(tempDate);
  newDate.setMonth(monthIndex);
  setTempDate(newDate);
};

const handleDayClick = (day) => {
  const newDate = new Date(tempDate);
  newDate.setDate(day);
  setTempDate(newDate);
};

const handleSubmit = () => {
  setCurrentDate(tempDate);
  setLocation(tempLocation);
};

  const handleChange = (e) => {
    const value = e.target.value;
    setTempLocation(value);

    // filter cities when user types
    if (value.length > 0) {
      const filtered = city.filter((c) =>
        c.city.toLowerCase().includes(value.toLowerCase())
      );
      setSuggestions(filtered.slice(0, 4)); // show only first 4 results
    } else {
      setSuggestions([]);
    }
  };

  const handleSelect = (cityName) => {
    setTempLocation(cityName);
    setSuggestions([]);
  };

// const formatTime = (time, mode) => {
//   if (!time || typeof time !== 'string') return "N/A";

//   const [start, end] = time.split(" to ");

//   const parseTime = (t) => {
//     if (!t) return "N/A";
//     const [hourMin, ampm] = t.trim().split(' ');
//     let [hour, minute] = hourMin.split(':').map(Number);
//     const isPM = ampm?.toLowerCase() === 'pm';

//     if (mode === '12') {
//       const suffix = isPM ? 'PM' : 'AM';
//       hour = hour % 12 || 12;
//       return `${hour}:${minute.toString().padStart(2, '0')} ${suffix}`;
//     }

//     if (mode === '24') {
//       return `${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}`;
//     }

//     if (mode === '24Plus') {
//       if (isPM && hour < 12) hour += 12;
//       if (!isPM && hour === 12) hour = 0;
//       return `${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}`;
//     }

//     return t;
//   };

//   return `${parseTime(start)} to ${parseTime(end)}`;
// };


  const formattedDate = currentDate.toISOString().split("T")[0];
  const readableDate = `${months[currentDate.getMonth()]} ${currentDate.getDate()}, ${currentDate.getFullYear()}`;
  const weekDay = currentDate.toLocaleDateString("en-US", { weekday: "long" });
const [selectedGhati, setSelectedGhati] = useState(null);




  return (
    <div className="doghati-container">
      <InnerNav />
      <div className="doghati-content">
        <Zodiac />
        <div className="do-ghati-details">
                <div className="title">Do Ghati Muhurat Table</div>
                <div className="sub">Running Do Ghati Muhurat</div>
              <div className="header">
                <div className="img-details">
                  <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRW3C3Ty79k_gyPc3OD5oWmoWQk5nXn1bGIYQ&s" alt="err" />
                 
                    <div className="right">
                      <h3>Current Muhurat</h3>
                      {currentLagna ? (
                        <>
                          <p>Nakshatra: {currentLagna.nakshatra}</p>
                          <p>{currentLagna.division}</p>
                          <p>{`${currentLagna.start} to ${currentLagna.end}`}</p>
                        </>
                      ) : (
                        <p>No active Muhurat at this time.</p>
                      )}
                    </div>

                 

                </div>
                <div className="date-display">
                  <span className="day">{currentDate.getDate()}</span>
                  <span className="month">{readableDate}</span>
                </div>
              </div>

              <div className="controls">
                {/* <div className="mode-toggle">
                  <button onClick={() => setTimeFormat("12")} className={timeFormat === "12" ? "active" : ""}>12 Hour</button>
                  <button onClick={() => setTimeFormat("24")} className={timeFormat === "24" ? "active" : ""}>24 Hour</button>
                  <button onClick={() => setTimeFormat("24Plus")} className={timeFormat === "24Plus" ? "active" : ""}>24 Plus</button>
                </div> */}

                <div className="month-grid">
                  {months.map((month, i) => (
                    <button key={i} onClick={() => handleMonthClick(i)}>{month}</button>
                  ))}
                </div>

                <div className="day-grid">
                  {Array.from({ length: 31 }, (_, i) => (
                    <button key={i} onClick={() => handleDayClick(i + 1)}>{i + 1}</button>
                  ))}
                </div>

                 <div className="location-date">
                   <div className="input-with-icon">
                  <span className="icon">📍</span>
                  <input
                    type="text"
                    value={tempLocation}
                    onChange={handleChange}
                    placeholder="Enter location"
                  />
                  {suggestions.length > 0 && (
                    <ul className="dropdown">
                      {suggestions.map((c, idx) => (
                        <li key={idx} onClick={() => handleSelect(c.city)}>
                          {c.city}, {c.state}, {c.country}
                        </li>
                      ))}
                    </ul>
                  )}
                  </div>
                  <input
                    type="date"
                    value={tempDate.toISOString().split("T")[0]}
                    onChange={handleDateInput}
                  />
                  <button onClick={handlePrevDay}>Prev Day</button>
                  <button onClick={handleNextDay}>Next Day</button>
                  <button onClick={handleSubmit}>Submit</button>

                </div>
              </div>

<div className="muhurta-section">
  {!selectedGhati ? (
    /* ========= LIST VIEW ========= */
    <>
      <div className="muhurta-header">
        <div className="muhurta-date">
          {readableDate}, {weekDay}
        </div>
      </div>

      <div className="muhurta-columns day">
        <div className="muhurta-column full">
          {doghati?.segments?.map((item, idx) => (
            <div
              key={idx}
              className="muhurta-card orange clickable"
              onClick={() => setSelectedGhati(item)}
            >
              <div className="title">{item.division}</div>

              <div className="Nakshatra">
                Nakshatra: {item.nakshatra}
              </div>

              <div className="time">
                {`${item.start} to ${item.end}`}
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  ) : (
    /* ========= DETAIL VIEW ========= */
    <div className="doghati-detail-page">
      <button
        type="button"
        className="back-btn"
        onClick={() => setSelectedGhati(null)}
      >
        ← Back
      </button>

      <h2>{selectedGhati.division}</h2>

      <p>
        <strong>Time:</strong>{" "}
        {`${selectedGhati.start} to ${selectedGhati.end}`}
      </p>

      <p>
        <strong>Nakshatra:</strong>{" "}
        {selectedGhati.nakshatra}
      </p>

      <p className="description">
        {doGhatiDivisionTooltips[selectedGhati.division]}
      </p>
    </div>
  )}
</div>

            </div>

            <div className="muhurat-texts">
            <p>
                Ekadashi is a significant day in the Hindu calendar, observed on the
                eleventh day of each lunar fortnight. It is dedicated to Lord Vishnu
                and is considered an auspicious time for spiritual practices,
                fasting, and meditation.
            </p>
            <h4>About Ghati Muhurat Table</h4>
            <p>
                The day is divided into two parts: the day muhurtas and the night
                muhurtas. Each part has specific timings that are considered
                favorable for performing rituals and prayers.
            </p>
            <div className="random-info">
                <p>one complete day = 60 ghati</p>
                <p>1 ghati = 60 pala</p>
                <p>1 vipala = 60 valipta</p>
            </div>
            <p>
                The day muhurtas are typically observed during the daytime, while
                the night muhurtas are observed after sunset. Each muhurtas has its
                own significance and is believed to bring different benefits to the
                devotees.
            </p>
            <p>
                Devotees often engage in fasting, chanting, and performing rituals
                during these muhurtas to seek blessings and spiritual growth. The
                timings of the muhurtas are calculated based on the lunar calendar
                and can vary each month.
            </p>
            <div className="random-info">
                <p>one complete day = 60 ghati</p>
                <p>1 ghati = 60 pala</p>
                <p>1 vipala = 60 valipta</p>
            </div>
            <p>
                It is important to note that the timings of the muhurtas may vary
                based on geographical location and local customs. Devotees are
                encouraged to consult a reliable Hindu calendar or seek guidance
                from knowledgeable sources to ensure accurate observance of the
                Ekadashi muhurtas.
            </p>
            <ul>
                <li>rudra</li>
                <li>vishnu</li>
                <li>shiva</li>
                <li>ganesha</li>
                <li>hanuman</li>
                <li>shakti</li> 
                <li>shani</li>
                <li>navagraha</li>
            </ul>
            </div>
        <MuhuratLink/>
        {/* <CommentBox/> */}
      </div>
      <Footer />
    </div>
  );
};

export default DoGhati;
